<ng-container *transloco="let t;">
    <label class="col-form-label p-0" for="name">{{ field.label }}</label>
        <div class="input-group input-group-merge align-items-center">
        <input type="text" [disabled]="!canEdit" [(ngModel)]="_field.value" class="form-control signatureDueDatesInput" placeholder="-" aria-label="-" (blur)="onSigningDeadlineChange($event.target.value)" (keyup.enter)="onSigningDeadlineChange($event.target.value)" />
        <div class="input-group-append">
            <span class="input-group-text px-0 border-0 text-primary">{{t("Document signing or reminder days text (Template/Document - section) - Days")}}</span>
        </div>
    </div>
</ng-container>